import useSWR from 'swr'
import fetcher from '../../utils/fetcher'
import { ResponseData } from './types'

type ContentResponse =  {
  type: 'help' | 'introduction' | 'notic' | string&{}
  content: string
}[]

export default function useFetchContent() {
  const res = useSWR<ResponseData<ContentResponse>>('/content.php', fetcher.get)


  // const setContentState = useSetContentState()

  // if(res.data){
  //   setContentState(res.data.data)
  // }

  return res
}